import React from "react";
import {
  ActivityIndicator,
  GestureResponderEvent,
  Text,
  TouchableOpacity,
  TouchableOpacityProps,
  View,
} from "react-native";

type Props = Omit<TouchableOpacityProps, "onPress"> & {
  text: string;
  onPress?: (e: GestureResponderEvent) => void;
  disabled?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  textClassName?: string;
};

export const FormButton: React.FC<Props> = ({
  text,
  onPress,
  disabled,
  loading,
  icon,
  className = "",
  textClassName = "",
  ...rest
}) => {
  const isDisabled = !!disabled || !!loading;
  const bg = isDisabled ? "bg-gray-500" : "bg-blue-900 active:bg-blue-800";

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={isDisabled}
      accessibilityRole="button"
      accessibilityState={{ disabled: isDisabled, busy: !!loading }}
      activeOpacity={0.85}
      className={`w-full py-4 rounded-xl items-center justify-center ${bg} ${className}`}
      {...rest}
    >
      {loading ? (
        <ActivityIndicator size="small" color="#ffffff" />
      ) : (
        <View className="flex-row items-center justify-center gap-2">
          {icon}
          <Text className={`text-white font-bold text-base ${textClassName}`}>
            {text}
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
};

export default FormButton;
